module.exports = __webpack_public_path__ + "img/48_office_employee_man_growth_performance_board_chart_statics-256.637ea21c.png";